/**
 * BlogARAlmadarBlogPage
 *
 * Page component for BlogARAlmadarBlogPage
 * Path: /ar/blog
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { BlogARBlogPageView as __BlogARBlogPageView } from '@/components/traits/BlogARBlogPageView';
import { BlogARBlogAnalyticsView as __BlogARBlogAnalyticsView } from '@/components/traits/BlogARBlogAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface BlogARAlmadarBlogPageProps {
  // Add any page-level props here
}

export function BlogARAlmadarBlogPage(_props: BlogARAlmadarBlogPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-blog:meta.title"],"description":["i18n/t","std-almadar-blog:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/blog"},{"locale":"ar","path":"/ar/blog"},{"locale":"sl","path":"/sl/blog"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__BlogARBlogPageView config={{ initPayload: __navState }} />
          <__BlogARBlogAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default BlogARAlmadarBlogPage;
